import React from 'react';
export function EyedropperIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.221 2.2a2.973 2.973 0 012.166.853c1.211 1.21 1.089 3.155-.09 4.334l-3.03 3.03a1 1 0 01-1.414 0l-2.83-2.83a1 1 0 010-1.414l3.03-3.03A3.153 3.153 0 0119.22 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.74 5.87a1 1 0 01.707.293l2.83 2.83a1 1 0 010 1.414l-7.9 7.9a14.216 14.216 0 01-6.84 3.797 1 1 0 01-1.201-1.2 14.216 14.216 0 013.797-6.841l7.9-7.9a1 1 0 01.707-.293zm0 2.414l-7.193 7.193A12.21 12.21 0 004.83 19.61a12.209 12.209 0 004.133-2.717L16.156 9.7 14.74 8.284z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.861 6.923a1 1 0 010-1.414l.757-.757a1 1 0 011.414 0l5.657 5.657a1 1 0 010 1.414l-.756.757a1 1 0 01-1.415 0l-5.657-5.657zM6.62 14h5.66v2H6.62v-2z"
  }));
}